import styled from "styled-components";
import {motion} from "framer-motion";
import React, {useEffect, useState} from "react";
import {Button} from "../../components/Button";
import {getSizeForLayout} from "../../utils/getSizeForLayout";
import {useAppContext} from "../../provider/AppProvider";
import {useViewPortState} from "../../provider/ResizeProvider";

const overlayVariants = {
    open: {
        opacity: 1,
        transition: {
            duration: 0.1,
            ease: "easeOut",
        },
    },
    closed: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: "easeOut",
        },
    }
}

const modalVariants = {
    open: {
        scale: [0.5, 1.15, 1.0],
        transition: {
            duration: 0.1,
            type: 'spring',
            damping: 25,
            stiffness: 500,
        }
    },
    closed: {
        scale: [1, 0],
    }
}

const Root = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 443213123;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Overlay = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    background: rgba(65, 67, 73, 0.9);
    z-index: -1;
`

const ModalRoot = styled(motion.div)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 8px;
`;

const ButtonWrapper = styled.div`
    width: 120px;
    height: 100px;
`;

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export const LanguageModal = ({isOpen, onClose}: Props) => {
    const {isDesktopState, isTableState} = useViewPortState();
    const {lang, onSetLang} = useAppContext();
    const [isVisible, setVisible] = useState<null | boolean>(null);

    useEffect(() => {
        setVisible(isOpen);
    }, [isOpen]);

    useEffect(() => {
        if (isVisible === false) {
            setTimeout(() => {
                onClose();
            }, 300)
        }
    }, [isVisible])

    const handleCloseModal = () => {
        setVisible(false);
    }

    return (
        <Root>
            <Overlay
                onClick={handleCloseModal}
                initial="closed"
                animate={isVisible ? "open" : "closed"}
                variants={overlayVariants}
            />
            <ModalRoot variants={modalVariants} animate={isVisible ? "open" : "closed"}>
                <ButtonWrapper>
                    <Button isAnimateShine={lang === 'ru'} sizeImageWidth={100} padding={4} onClick={() => {
                        onSetLang('ru');
                        handleCloseModal();
                    }} iconName='ru'
                            size={getSizeForLayout({m: 79, t: 79, d: 79, isTable: isTableState, isDesktop: isDesktopState})}/>
                </ButtonWrapper>
                <ButtonWrapper>
                    <Button isAnimateShine={lang === 'en'} sizeImageWidth={100} padding={4} onClick={() => {
                        onSetLang('en');
                        handleCloseModal();
                    }} iconName='en'
                            size={getSizeForLayout({m: 79, t: 79, d: 79, isTable: isTableState, isDesktop: isDesktopState})}/>
                </ButtonWrapper>
                <ButtonWrapper>
                    <Button isAnimateShine={lang === 'tr'} sizeImageWidth={100} padding={4} onClick={() => {
                        onSetLang('tr');
                        handleCloseModal();
                    }} iconName='tr'
                            size={getSizeForLayout({m: 79, t: 79, d: 79, isTable: isTableState, isDesktop: isDesktopState})}/>
                </ButtonWrapper>
            </ModalRoot>
        </Root>
    )

}